export enum Locales {
  Nl = 'nl',
  En = 'en',
  De = 'de',
  Fr = 'fr',
}

export enum UserEditActions {
  Create,
  Inactive,
  Update,
  Delete,
  Active,
}

export enum CompanyEditActions {
  Create,
  Inactivate,
  Update,
  Delete,
  Activate,
}

export enum NotificationEditActions {
  Create,
  Update,
  Delete
}

export interface IMessage {
  message: string,
  detailedMessage: string,
}

export interface IRequestPayload<TEntity> {
  entity?: TEntity
  path?: string
}

export interface IValidationError {
  name: string
  reason: string
}

export interface IResponseException {
  exceptionMessage: string
  validationErrors: IValidationError[]
}

export interface IResponse<TEntity> {
  message: string
  isError: boolean
  result: TEntity
  responseException: IResponseException
}

export interface IPagedResult<TEntity> {
  content?: TEntity[] | undefined
  currentPage?: number
  itemsPerPage?: number
  totalItems?: number
  readonly totalPages?: number
}

export interface IFilter {
  key: string
  value: string | string[]
}

export enum SortOrder {
  asc = 'ASC',
  desc = 'DESC'
}

export enum DocumentDetailType {
  version = 'version',
  batch = 'batch'
}

export interface ISort {
  sortField: string
  sortOrder: SortOrder
}

export enum DocumentBlockType {
  row,
  block,
  download
}

export enum DocumentSortOptions {
  uploadDateAsc = 'uploadDateAsc',
  uploadDateDesc = 'uploadDateDesc',
  documentTypeAsc = 'documentTypeAsc',
}
